import React from "react"

export function LoadingSpinner({ size = "md" }) {
  const dimensions = size === "sm" ? "h-5 w-5 border-2" : "h-16 w-16 border-4"
  return <span className={`inline-block animate-spin rounded-full border-solid border-[#F3E7D5] border-t-[#D4A017] ${dimensions}`} aria-hidden="true" />
}

export function LoadingButton({ children }) {
  return <span className="inline-flex items-center justify-center gap-2"><LoadingSpinner size="sm" />{children}</span>
}

export default function LoadingState({ label = "Loading…", compact = false }) {
  return <div role="status" aria-live="polite" className={`grid place-items-center text-center ${compact ? "min-h-48 py-8" : "min-h-[55vh] px-5 py-16"}`}>
    <div>
      <div className="relative mx-auto grid h-24 w-24 place-items-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-[#D4A017]/10" aria-hidden="true" />
        <LoadingSpinner />
        <img src="/brand/saamling-mark-dark.jpg" alt="" className="absolute h-11 w-11 rounded-xl object-cover shadow-md" />
      </div>
      <p className="mt-5 font-bold text-[#0B2D5B]">{label}</p>
      <div className="mt-3 flex justify-center gap-1.5" aria-hidden="true">{[0,1,2].map(index=><span key={index} className="h-2 w-2 animate-bounce rounded-full bg-[#D4A017]" style={{animationDelay:`${index*140}ms`}} />)}</div>
    </div>
  </div>
}
